export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14132.2d958cd5.jpg";